module.exports = __webpack_public_path__ + "resources/img/ico-company-aboutteam-ifg-2@2x.449e4047.png";